import { useAsyncData } from '#imports'
import { computed, watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import type { ReviewerInfo } from '../../../api/reviews/types'

export function useFetchReviewerInfo(customerId: string | undefined) {
  const $httpFetch = useHttpFetch()
  const logger = useLogger()

  const { data, error, execute, status } = useAsyncData<ReviewerInfo>(
    `reviews-reviewer-info-${customerId}`,
    async () => {
      if (!customerId) return {}

      return $httpFetch('/reviews/v1/customers/:customerId', {
        pathParams: { customerId },
      })
    },
    { server: false, immediate: false, dedupe: 'defer' },
  )

  // since immediate: false the useAsyncData pending checks for status pending or idle
  // we don't want idle to return a truthy value, so we check the pending state here.
  const pending = computed(() => status.value === 'pending')

  watch(error, () => {
    if (!error.value) return

    logger.error('[REVIEWS][ReviewerInfo]', {
      error: error.value as Error,
      owners: ['bot-squad-content-front'],
    })
  })

  return { data, pending, execute }
}
